// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CommunityActions {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 440px; /* Sets the maximum width */
  height: 63px;
  margin-top: 20px;
  border-radius: 20px;
  /* background-color: #efeeed;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5); */
  background-color: white;
  border: solid 1px #dee0e1;
  cursor: pointer;
}

.CommunityActions img {
  width: 20px;
  margin-right: 10px;
  margin-left: 10px;
}

.CommunityActions p, .CommunityActions a {
  font-size: 18px;
  margin: 0;
  padding: 0 10px;
  flex: 1 1;
}

@media (min-width: 320px) {
  .CommunityActions {
    max-width: 310px;
  }
}

@media (min-width: 425px) {
  .CommunityActions {
    max-width: 380px;
  }
}

@media (min-width: 768px) {
  .CommunityActions {
    max-width: 350px;
  }
}

@media (min-width: 992px) {
  .CommunityActions {
    max-width: 440px;
  }
}


.communitiesMainContainer{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Community/Community.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB,EAAE,2BAA2B;EAC7C,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB;;8CAE4C;EAC5C,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,eAAe;EACf,SAAO;AACT;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".CommunityActions {\r\n  display: flex;\r\n  align-items: center;\r\n  width: 100%;\r\n  max-width: 440px; /* Sets the maximum width */\r\n  height: 63px;\r\n  margin-top: 20px;\r\n  border-radius: 20px;\r\n  /* background-color: #efeeed;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n  background-color: white;\r\n  border: solid 1px #dee0e1;\r\n  cursor: pointer;\r\n}\r\n\r\n.CommunityActions img {\r\n  width: 20px;\r\n  margin-right: 10px;\r\n  margin-left: 10px;\r\n}\r\n\r\n.CommunityActions p, .CommunityActions a {\r\n  font-size: 18px;\r\n  margin: 0;\r\n  padding: 0 10px;\r\n  flex: 1;\r\n}\r\n\r\n@media (min-width: 320px) {\r\n  .CommunityActions {\r\n    max-width: 310px;\r\n  }\r\n}\r\n\r\n@media (min-width: 425px) {\r\n  .CommunityActions {\r\n    max-width: 380px;\r\n  }\r\n}\r\n\r\n@media (min-width: 768px) {\r\n  .CommunityActions {\r\n    max-width: 350px;\r\n  }\r\n}\r\n\r\n@media (min-width: 992px) {\r\n  .CommunityActions {\r\n    max-width: 440px;\r\n  }\r\n}\r\n\r\n\r\n.communitiesMainContainer{\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin-bottom: 20px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
